module.exports = __webpack_public_path__ + "static/media/announcementActive.5f06afcc.png";